/**
 * Governance RH Service
 * Conectado ao banco via /api/governance/rh/*
 * Tabelas: hr_people + hr_headcount_plan (migration 272)
 */
import { AZURE } from './api';

export const RH_COST_CENTERS = [
  'Administração / Estratégia',
  'Produto',
  'Tecnologia / Infraestrutura',
  'IA / Dados',
  'Comercial',
  'Marketing',
  'Operações',
  'Financeiro',
  'Jurídico / Compliance',
];

export const RH_FINANCIAL_CATEGORIES = [
  'Pró-labore',
  'Salários CLT',
  'Prestadores PJ',
  'Bolsas / Estágio',
  'Encargos trabalhistas',
  'Benefícios',
  'Bônus / variável',
  'Equity sem impacto de caixa',
  'Outros',
];

export const RH_SCENARIOS = ['Conservador', 'Base', 'Agressivo', 'Não definido'];

// ─── People ────────────────────────────────────────────────────────────────

export const listPeople = async (status = null) => {
  const params = status ? { status } : {};
  const { data } = await AZURE.get('/governance/rh/people', { params });
  return data;
};

export const savePerson = async (payload) => {
  const { data } = await AZURE.post('/governance/rh/people', payload);
  return data;
};

export const updatePerson = async (personId, payload) => {
  const { data } = await AZURE.patch(`/governance/rh/people/${personId}`, payload);
  return data;
};

export const updateProLabore = async (personId, payload) => {
  const { data } = await AZURE.patch(`/governance/rh/people/${personId}/pro-labore`, payload);
  return data;
};

export const deletePerson = async (personId) => {
  const { data } = await AZURE.delete(`/governance/rh/people/${personId}`);
  return data;
};

// ─── Compensation ──────────────────────────────────────────────────────────

export const listCompensation = async () => {
  const { data } = await AZURE.get('/governance/rh/compensation');
  return data;
};

// ─── Headcount Plan ────────────────────────────────────────────────────────

export const listHeadcountPlan = async () => {
  const { data } = await AZURE.get('/governance/rh/headcount-plan');
  return data;
};

export const saveHeadcountPlan = async (payload) => {
  const { data } = await AZURE.post('/governance/rh/headcount-plan', payload);
  return data;
};

export const updateHeadcountPlan = async (planId, payload) => {
  const { data } = await AZURE.patch(`/governance/rh/headcount-plan/${planId}`, payload);
  return data;
};

export const deleteHeadcountPlan = async (planId) => {
  const { data } = await AZURE.delete(`/governance/rh/headcount-plan/${planId}`);
  return data;
};

// ─── Permissions ───────────────────────────────────────────────────────────

export const listGovernancePermissions = async () => {
  const { data } = await AZURE.get('/governance/rh/permissions');
  return data;
};

export const savePermission = async (payload) => {
  // Placeholder — implementar quando tabela gov_user_roles estiver pronta
  return { success: true, data: payload };
};

// ─── Financial Projection ──────────────────────────────────────────────────

export const listFinancialHrProjection = async () => {
  const { data } = await AZURE.get('/governance/rh/financial-projection');
  return data;
};
